import { render } from "./Team_adviser_m.vue?vue&type=template&id=fcfa5b64&scoped=true"
import script from "./Team_adviser_m.vue?vue&type=script&lang=js"
export * from "./Team_adviser_m.vue?vue&type=script&lang=js"

import "./Team_adviser_m.vue?vue&type=style&index=0&id=fcfa5b64&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fcfa5b64"

export default script